import React, { useMemo } from 'react'

import * as ArticleComponents from 'components/ArticleComponents'
import Copyable from 'components/Copyable'

import Data from '../TestCards.yaml'

const getCardNetworkName = networkId => Data.cardNetworks[networkId]?.name ?? networkId

const CardNumber = ({ value }) => (
	<Copyable value={value}>
		<ArticleComponents.Code>{value}</ArticleComponents.Code>
	</Copyable>
)

const TestCardsTable = ({ getCards }) => {
	const cards = useMemo(() => {
		if (!getCards) {
			return []
		}

		return getCards(Data)
	}, [getCards])

	const hasScenario = !!cards.find(card => card.scenario)
	const hasAmount = !!cards.find(card => !isNaN(card.amount))
	const hasPlatform = !!cards.find(card => card.platform)
	const hasAccountFundingType = !!cards.find(card => card.accountFundingType)

	return (
		<ArticleComponents.HorizontalScrollTable>
			<thead>
				<tr>
					{hasScenario && <th>Scenario</th>}
					<th>Card Network</th>
					{hasPlatform && <th>Platform</th>}
					<th>Card Number</th>
					<th>CVV</th>
					<th>Expiry date</th>
					{hasAmount && <th>Amount</th>}
					{hasAccountFundingType && <th>Account Funding Type</th>}
				</tr>
			</thead>

			<tbody>
				{cards.map(card => (
					<tr key={card.number}>
						{hasScenario && <td>{card.scenario}</td>}
						<td>{getCardNetworkName(card.network)}</td>
						{hasPlatform && <td>{card.platform}</td>}
						<td>
							<CardNumber value={card.number} />
						</td>
						<td>Any 3 digit number</td>
						<td>Any future expiry date</td>
						{hasAmount && <td>{card.amount}</td>}
						{hasAccountFundingType && <td>{card.accountFundingType}</td>}
					</tr>
				))}
			</tbody>
		</ArticleComponents.HorizontalScrollTable>
	)
}

export default TestCardsTable
